// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileAggregatorResponseDto
 */
export interface IFileAggregatorResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    file_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    file_type?: IFileAggregatorResponseDtoFileTypeEnum;
    /**
     * 
     * @type {Set<string>}
     * @memberof IFileAggregatorResponseDto
     */
    partners?: Set<string>;
    /**
     * 
     * @type {Set<string>}
     * @memberof IFileAggregatorResponseDto
     */
    employers?: Set<string>;
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    uploaded_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    processed_by?: string;
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    upload_way?: IFileAggregatorResponseDtoUploadWayEnum;
    /**
     * 
     * @type {Date}
     * @memberof IFileAggregatorResponseDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IFileAggregatorResponseDto
     */
    processed_at?: Date;
    /**
     * 
     * @type {string}
     * @memberof IFileAggregatorResponseDto
     */
    file_processing_status_type?: IFileAggregatorResponseDtoFileProcessingStatusTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFileAggregatorResponseDtoFileTypeEnum {
    CENSUS = 'CENSUS',
    ENROLLMENT = 'ENROLLMENT',
    CONTRIBUTION = 'CONTRIBUTION',
    MD = 'MD',
    ED = 'ED',
    BAI2 = 'BAI2',
    BR = 'BR',
    MIXED = 'MIXED',
    CIP = 'CIP',
    ISO_302 = 'ISO_302',
    UNKNOWN = 'UNKNOWN',
    PGP_BAI2 = 'PGP_BAI2',
    CARRIER = 'CARRIER',
    ACH = 'ACH',
    CHECK_PAID = 'CHECK_PAID',
    CHECK_CANCELLED = 'CHECK_CANCELLED',
    DEPENDENT = 'DEPENDENT',
    BALANCE_ADJUSTMENT = 'BALANCE_ADJUSTMENT'
}
/**
* @export
* @enum {string}
*/
export enum IFileAggregatorResponseDtoUploadWayEnum {
    FTP = 'FTP',
    UI = 'UI'
}
/**
* @export
* @enum {string}
*/
export enum IFileAggregatorResponseDtoFileProcessingStatusTypeEnum {
    INITIATED = 'INITIATED',
    UPLOADED = 'UPLOADED',
    PARSED = 'PARSED',
    VALIDATED = 'VALIDATED',
    APPROVED = 'APPROVED',
    PROCESSING = 'PROCESSING',
    COMPLETED = 'COMPLETED',
    QUALITY_GATES_FAILED = 'QUALITY_GATES_FAILED',
    ERROR = 'ERROR',
    DUPLICATE = 'DUPLICATE',
    CANCELLED = 'CANCELLED'
}


/**
 * Check if a given object implements the IFileAggregatorResponseDto interface.
 */
export function instanceOfIFileAggregatorResponseDto(value: object): value is IFileAggregatorResponseDto {
    return true;
}

export function IFileAggregatorResponseDtoFromJSON(json: any): IFileAggregatorResponseDto {
    return IFileAggregatorResponseDtoFromJSONTyped(json, false);
}

export function IFileAggregatorResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileAggregatorResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_name': json['file_name'] == null ? undefined : json['file_name'],
        'file_type': json['file_type'] == null ? undefined : json['file_type'],
        'partners': json['partners'] == null ? undefined : new Set(json['partners']),
        'employers': json['employers'] == null ? undefined : new Set(json['employers']),
        'uploaded_by': json['uploaded_by'] == null ? undefined : json['uploaded_by'],
        'processed_by': json['processed_by'] == null ? undefined : json['processed_by'],
        'upload_way': json['upload_way'] == null ? undefined : json['upload_way'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'processed_at': json['processed_at'] == null ? undefined : (new Date(json['processed_at'])),
        'file_processing_status_type': json['file_processing_status_type'] == null ? undefined : json['file_processing_status_type'],
    };
}

export function IFileAggregatorResponseDtoToJSON(json: any): IFileAggregatorResponseDto {
    return IFileAggregatorResponseDtoToJSONTyped(json, false);
}

export function IFileAggregatorResponseDtoToJSONTyped(value?: IFileAggregatorResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_name': value['file_name'],
        'file_type': value['file_type'],
        'partners': value['partners'] == null ? undefined : Array.from(value['partners'] as Set<any>),
        'employers': value['employers'] == null ? undefined : Array.from(value['employers'] as Set<any>),
        'uploaded_by': value['uploaded_by'],
        'processed_by': value['processed_by'],
        'upload_way': value['upload_way'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'processed_at': value['processed_at'] == null ? undefined : ((value['processed_at']).toISOString()),
        'file_processing_status_type': value['file_processing_status_type'],
    };
}

